import React, { useState, useEffect } from 'react'

import "./../styles/scavengerhunt.css";
import { Link } from 'react-router-dom'

import GameNav from '../GameNav'

const ScavengerHunt = () => {
    const initializeHunt = Array(9).fill(null);
    const [hunt, setHunt] = useState(initializeHunt);
    const [win, setWin] = useState(false);
    const [mobile, setMobile] = useState(false);


    const itemClick = (index) => {
        if (win || hunt[index] !== null) {
            return
        }
        const updatedHunt = [...hunt];
        updatedHunt[index] = true;
        setHunt(updatedHunt);

        if (updatedHunt.every((item) => item === true)) {
            setWin(true);
        }
    }

    const calculatePicHeight = () => {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        if (windowWidth > windowHeight) {
            setMobile(false);
            return (windowWidth * 0.8) * 0.5625;
        } else {
            setMobile(true);
            return windowHeight * 0.8;
        }
    };

    let screenWidth = window.innerWidth;
    const [winWidth, trackWinWidth] = useState(screenWidth);

    const [picHeight, setPicHeight] = useState(calculatePicHeight);


    const resetGame = () => {
        setWin(false);
        setHunt(initializeHunt);
    }



    useEffect(() => {
        const handleResize = () => {
            setPicHeight(calculatePicHeight());
        };

        const setWindowWidth = () => {
            trackWinWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('windowWidth', setWindowWidth);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('windowWidth', setWindowWidth);
        };
    }, []);


    const foundItemsCount = hunt.filter((item) => item === true).length;

    // <div className={`${win ? 'image-blur' : ''}`}>
    return (
        <div className='scavenger-main'>

            <GameNav />

            {!win ? (
                <></>
            ) : (
                <div id='winning-screen'>
                    <h3 id='win-greeting' className='animate__animated animate__bounce'>Nice Work! You Found them All</h3>
                    <button className='animate__animated animate__bounce after-game-home-btn'>
                        <Link style={{ textDecoration: 'none', color: 'white' }} to='/'>
                            Home
                        </Link>

                    </button>
                </div>
            )}


            <div id='instructions-anim'>
                <h3>Find All Items</h3>
                <h4>Some Items may appear more than once</h4>
            </div>


            {mobile ? (
                <div className='animate__animated animate__bounce' id='scroll-anim'>
                    <img src={process.env.PUBLIC_URL + 'images/arrow-left.png'} height='20px'></img>
                    <p>Scroll</p>
                    <img src={process.env.PUBLIC_URL + 'images/arrow-right.png'} height='20px'></img>
                </div>
            ) : (
                <div>
                </div>
            )

            }

            {/* 
height: picHeight */}

            <div id='scav-hunt-container' >
                <div className={`${mobile ? 'scavMobile' : 'scavDesktop'}`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt.png)`, height: picHeight }} id='image-outer'>

                    <div
                        onClick={() => itemClick(0)}
                        className={`item ${hunt[0] !== null ? 'found' : ''}`}
                        id='item-1'
                    >

                    </div>
                    <div
                        onClick={() => itemClick(1)}
                        className={`item ${hunt[1] !== null ? 'found' : ''}`}
                        id='item-2'
                    >

                    </div>
                    <div
                        onClick={() => itemClick(2)}
                        className={`item ${hunt[2] !== null ? 'found' : ''}`}
                        id='item-3'
                    >

                    </div>
                    <div
                        onClick={() => itemClick(3)}
                        className={`item ${hunt[3] !== null ? 'found' : ''}`}
                        id='item-4'
                    >

                    </div>
                    <div
                        onClick={() => itemClick(4)}
                        className={`item ${hunt[4] !== null ? 'found' : ''}`}
                        id='item-5'
                    >

                    </div>

                    <div
                        onClick={() => itemClick(5)}
                        className={`item ${hunt[5] !== null ? 'found' : ''}`}
                        id='item-6'
                    >
                    </div>


                    <div
                        onClick={() => itemClick(6)}
                        className={`item ${hunt[6] !== null ? 'found' : ''}`}
                        id='item-7'
                    >
                    </div>

                    <div
                        onClick={() => itemClick(7)}
                        className={`item ${hunt[7] !== null ? 'found' : ''}`}
                        id='item-8'
                    >
                    </div>

                    <div
                        onClick={() => itemClick(8)}
                        className={`item ${hunt[8] !== null ? 'found' : ''}`}
                        id='item-9'
                    >
                    </div>


                </div>

            </div>


            <div className={`scavenger-control-panel ${mobile ? 'scavctrMobile' : 'scavctrDesktop'}`} >
                <div className='scavenger-hunt-control'
                >
                    <div id='scavenger-control-1'>
                        <div id='items-list'>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/tree.png)` }}>
                                {hunt[0] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/cake.png)` }}>
                                {hunt[1] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/glasses.png)` }}>
                                {hunt[2] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/pickles.png)` }}>
                                {hunt[3] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/lawnmower.png)` }}>
                                {hunt[4] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/panda.png)` }}>
                                {hunt[5] === true && hunt[6] === true ? (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                ) : (
                                    <h3></h3>
                                )}
                            </div>

                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/note.png)` }}>
                                {hunt[7] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>
                            <div className='item-icon' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt/chandlier.png)` }}>
                                {hunt[8] === null ? (
                                    <h3></h3>
                                ) : (
                                    <img className='check-mark' src={process.env.PUBLIC_URL + 'images/check-mark.png'}></img>
                                )}
                            </div>
                        </div>
                    </div>
                    <div id='scavenger-control-2'>



                        <svg className='wheel' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 402.33 402.32">
                            <path d="M485.74,660.44h0V600h0a200.32,200.32,0,0,0-126.63,44.87L398,691.17A140.08,140.08,0,0,1,485.74,660.44Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 1 ? 'find-count' : ''}`}
                            />
                            <path d="M574.07,691.63l38.87-46.33A200.34,200.34,0,0,0,485.74,600v60.46A140.11,140.11,0,0,1,574.07,691.63Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 9 ? 'find-count' : ''}`}
                            />
                            <path d="M398,691.17l-38.87-46.32a201,201,0,0,0-70.37,115.43l59.6,10.51A140.67,140.67,0,0,1,398,691.17Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 2 ? 'find-count' : ''}`}
                            />
                            <path d="M623.68,773.31l59.57-10.5A201.08,201.08,0,0,0,612.94,645.3l-38.87,46.33A140.63,140.63,0,0,1,623.68,773.31Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 8 ? 'find-count' : ''}`}
                            />
                            <path d="M683.25,762.81l-59.57,10.5a141.05,141.05,0,0,1-15.17,96.59l52.38,30.24a200.21,200.21,0,0,0,26-99A202.51,202.51,0,0,0,683.25,762.81Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 7 ? 'find-count' : ''}`}
                            />
                            <path d="M485.74,941.84a140.2,140.2,0,0,1-52.48-10.13l-20.69,56.86a201.85,201.85,0,0,0,140.7,2.1l-20.68-56.83A140.58,140.58,0,0,1,485.74,941.84Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 5 ? 'find-count' : ''}`}
                            />
                            <path d="M532.59,933.84l20.68,56.83a201.8,201.8,0,0,0,107.62-90.53L608.51,869.9A141.13,141.13,0,0,1,532.59,933.84Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 6 ? 'find-count' : ''}`}
                            />
                            <path d="M345.05,801.14a141.19,141.19,0,0,1,3.29-30.35l-59.6-10.51a201.76,201.76,0,0,0,19.61,135.77l52.41-30.26A140,140,0,0,1,345.05,801.14Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 3 ? 'find-count' : ''}`}
                            />
                            <path d="M360.76,865.79l-52.41,30.26a201.88,201.88,0,0,0,104.22,92.52l20.69-56.86A141.16,141.16,0,0,1,360.76,865.79Z" transform="translate(-284.58 -599.98)"
                                className={`wheel-slice a ${foundItemsCount >= 4 ? 'find-count' : ''}`}
                            />

                            <text fill='white' x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="wheel-text">
                                {foundItemsCount} / 9
                            </text>
                        </svg>


                    </div>


                </div>



            </div>


        </div>
    )
}

export default ScavengerHunt